import Api from "./api";

class PortallSettingsApi {
	static get = () => {
		const url = `v1/portalsettings`;
		return Api
			.get(url)
			.then(response => {
				return response.data;
			});
	};
	
}

export default PortallSettingsApi;